<template>
  <div class="custom-list-wrapper">
    <div v-show="$loading.isLoading('getContactPhones') || $loading.isLoading('getContactAddresses')">
      <span>Loading...</span>
    </div>
    <div
      class="custom-list-header"
      v-show="!$loading.isLoading('getContactPhones') && !$loading.isLoading('getContactAddresses')"
    >
      <b-button
        variant="outline-secondary"
        size="sm"
        @click="newPhone"
      >Add</b-button>
      <b-button
        variant="outline-secondary"
        size="sm"
        @click="confirmDelete"
        v-show="isShowDelete"
      >Delete</b-button>
      <b-button
        variant="outline-secondary"
        size="sm"
        @click="primaryPhone"
        v-show="isShowPrimary"
      >Set as Primary</b-button>
      <span
        class="custom-title"
        v-show="showTitle"
      >Phones</span>
    </div>
    <div
      class="custom-list"
      v-show="!$loading.isLoading('getContactPhones')"
    >
      <div
        v-for="item of contactPhones"
        :key="item.contactPhone"
      >
        <contact-phone-record
          :recordData="item"
          @itemChecked="itemChecked"
          @editItem="editPhone"
        />
      </div>
    </div>
    <dialog-phone
      v-model="actionPhone"
      :phone="phoneRecord"
      @closing="closeModal"
      @send="sendPhone"
    />
    <confirm-delete
      v-model="actionDelete"
      :tag="'Phone(s)'"
      @closing="closeModal"
      @delete="performDelete"
    />
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import DialogPhone from '@/components/contacts/forms/phone'
import ContactPhoneRecord from '@/components/contacts/listings/contact-phone-record'
import ConfirmDelete from '@/components/contacts/forms/confirm-delete'
export default {
  name: 'contact-phones',
  components: {
    DialogPhone,
    ContactPhoneRecord,
    ConfirmDelete
  },
  props: {
    contact: {
      type: Object
    },
    showTitle: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      actionPhone: null,
      actionDelete: null,
      isShowDelete: false,
      isShowPrimary: false,
      recordChecked: null,
      phoneRecord: undefined
    }
  },
  computed: {
    ...mapGetters('contacts', ['contactPhones'])
  },
  methods: {
    ...mapActions('contacts', [
      'savePhone',
      'deletePhone',
      'setPrimaryPhone',
      'setCheckedPhone',
      'getContactPhones',
      'addPhone'
    ]),
    closeModal() {
      this.actionPhone = null
      this.actionDelete = null
      this.phoneRecord = undefined
      this.recordChecked = null
    },
    itemChecked(value, checked) {
      this.isShowDelete = checked
      this.isShowPrimary = checked
      this.recordChecked = null
      if (checked) {
        this.recordChecked = value
      }
      this.setCheckedPhone({
        contactPhone: value.contactPhone,
        isChecked: checked
      })
    },
    newPhone() {
      var phone = {
        firm: this.contact.firm,
        contact: this.contact.contact,
        contactPhone: -1,
        extension: '',
        isShared: false,
        phone: -1,
        phoneNo: '',
        phoneNote: '',
        phoneType: 0,
        phoneTypeName: '',
        primary: ''
      }
      this.addPhone(phone)
      this.phoneRecord = phone
      this.actionPhone = this.contact
    },
    editPhone(data) {
      this.phoneRecord = data
      this.actionPhone = this.contact
    },
    confirmDelete() {
      this.actionDelete = true
    },
    async performDelete() {
      this.actionDelete = false
      this.isShowDelete = false
      this.isShowPrimary = false
      this.recordChecked = null
      let phones = []
      for (let phone of this.contactPhones) {
        if (phone.isChecked) {
          phones.push({
            contactPhone: phone.contactPhone,
            contact: this.contact.contact
          })
        }
      }
      for (let phone of phones) {
        await this.deletePhone(phone)
      }
      await this.getContactPhones(this.contact.contact)
    },
    async primaryPhone() {
      let data = {
        id: this.recordChecked.contactPhone,
        contact: this.contact.contact
      }
      await this.setPrimaryPhone(data)
      this.isShowDelete = false
      this.isShowPrimary = false
      this.recordChecked = null
    },
    async sendPhone(data) {
      this.actionPhone = null
      this.phoneRecord = undefined
      var phone = this.contactPhones.find(
        x => parseInt(x.contactPhone) === parseInt(data)
      )
      if (phone !== null) {
        if (phone.phone === -1) {
          phone.isPrimary = true
        }
        await this.savePhone(phone)
        await this.getContactPhones(this.contact.contact)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-list-wrapper {
  background-color: #ffffff;
  max-height: 210px;
  height: 210px;
  padding: 2px;
}
.custom-list-header {
  text-align: left;
  padding: 5px;
  border-bottom: 1px solid rgb(144, 144, 144);
  margin-bottom: 5px;
}
.custom-list {
  overflow-y: scroll;
  overflow-x: hidden;
  padding: 5px;
  margin-left: 5px;
  margin-right: 5px;
  height: 155px;
}
.custom-title {
  float: right;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/contacts/listings/contact-phones.vue